import { withCloseAfterExited } from "@10duke/dukeui";
import {
  default as View,
  UnassignAdminModalProps
} from "./unassign-admin-modal-view";

const UnassignAdminModal = withCloseAfterExited<UnassignAdminModalProps>(View);
export default UnassignAdminModal;
